// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1eVQ1","buttons":"PendingPaymentAlert_buttons__XS9l9"};